import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';

Vue.use(VueRouter);

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
  const user = localStorage.getItem('user');
  if (to.name.includes('ecotron') || to.name.includes('ecofrost')) {
    document.title = `${to.params.topic} | ${to.meta.title}`;
  } else {
    document.title = `${to.meta.title}`;
  }
  if (to.matched.some(record => record.meta.authRequired) && !user) {
    next({
      path: '/login'
    });
  }
  next();
});

export default router;
